class ScrollVideo
{
	static init()
	{

		const observer = new IntersectionObserver((entries) => {

			entries.forEach(entry => {

				const video = entry.target;

				if(entry.isIntersecting)
				{
					try {
						console.log("Playing", video);
						video.currentTime = 0;
						video.play().catch(() => {});
					} catch {}

				} else {
					console.log("Pausing", video);
					video.pause()
					video.currentTime = 0;
				}

			});

		}, {
			threshold: 0.65,
		});

		document.querySelectorAll("video").forEach(video => {
			observer.observe(video);
		});

	}

}

export default ScrollVideo;
